module.exports = __webpack_public_path__ + "static/media/cancel.761736ae.svg";